export function toMoneyNotation(val: number): string {
    let parts = val.toString().split('.');
    parts[0] = parts[0].split("").reverse().join("");
    parts[0] = parts[0].replace(/(\d{3})/g,"$1 ");
    parts[0] = parts[0].split("").reverse().join("").trim();
    if (parts[1] && parts[1].length === 1) parts[1] += '0'
    else if (!parts[1]) parts[1] = '00';
    return `€ ${parts[0]},${parts[1]}`;
}